import { Image } from "../Image";
import { Link } from "../Link";
import { List } from "../List";
import { Page } from "../Page";

export class MockPage implements Page {
  private static INDEX = 0;

  public uuid: string;
  public imgBackground?: Image | undefined;
  public imgIcon?: Image | undefined;
  public title?: string | undefined;
  public lists: List[];
  public isPaginated: boolean;
  public total: number;
  public links?: Link[];

  constructor() {
    this.lists = [];
    this.isPaginated = false;
    this.total = 0;
    MockPage.INDEX++;
    this.uuid = `${MockPage.INDEX}`;
  }
}
